import { forwardRef, type Ref, type SVGProps } from "react";
const IconStopOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 5v22l.2.1h21.7l.1-.2V5l-.2-.1H5zm-2 .2C3 4 4 3 5.2 3h21.6C28 3 29 4 29 5.2v21.6c0 1.2-1 2.2-2.2 2.2H5.2C4 29 3 28 3 26.8z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconStopOutlineSVG);
ForwardRef.displayName = "IconStopOutline";
export { ForwardRef as IconStopOutline };
